import {
  Button,
  Container,
  Grid,
  makeStyles,
  TextField,
  Paper,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import Header from "../component/header";
import Firebase from "../js/Firebase";
const useStyles = makeStyles((theme) => ({
  videos: {
    fontSize: 0,
    height: "100%",
    pointerEvents: "none",
    position: "absolute",
    transition: "all 1s",
    width: "100%",
  },
  mt24: {
    marginTop: 24,
  },
}));
const Caller = () => {
  const classes = useStyles();
  const [roomId, setRoomId] = useState("");
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    setRoomId(generateRandomNumber());
  }, []);
  const generateRandomNumber = () => {
    return Math.floor(Math.random() * 1000000000);
  };

  async function createRoom() {
    let d = {
      ts: Date.now(),
    };
    try {
      await Firebase.firestore()
        .collection("book")
        .doc("" + roomId)
        .set(d);
      setSuccess(true);
    } catch (e) {
      console.log(JSON.stringify(e));
    }
  }

  return (
    <div>
      <Header />
      {success ? <Redirect to={`/r/true/${roomId}`} /> : ""}
      <Container>
        <Grid
          className={classes.mt24}
          container
          spacing={2}
          align="center"
          justify="center"
          alignItems="center"
        >
          <Grid item md={4}>
            <Paper square style={{ padding: 24 }}>
              <Typography variant="h5">
                Enter Room id to create new meeting
              </Typography>
              <TextField
                style={{ marginTop: 54 }}
                fullWidth
                id="name"
                label="Room Id"
                value={roomId}
                onChange={(e) => setRoomId(e.target.value)}
                margin="normal"
              />
              <Button
                className={classes.mt24}
                color="primary"
                variant="contained"
                onClick={(e) => createRoom()}
              >
                Create Room
              </Button>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default Caller;
